import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { BookingObjectAttribute } from 'src/components/BookingObjectAttribute/BookingObjectAttribute';
import { Section } from 'src/components/Section/Section';
import { getParkingLocation } from 'src/store/parking/selectors';
import { toAddress } from 'src/utils/toAddress';

export interface BookingDataProps {
  guest: boolean;
}

export const BookingData: FC<BookingDataProps> = ({ guest }) => {
  const { town, building, floor } = useSelector(getParkingLocation);

  const bookingData = useMemo(
    () =>
      toAddress({
        town: town?.townName,
        building: building?.address,
        floor: floor?.title,
        skipFloorLabel: true,
      }),
    [building?.address, floor?.title, town?.townName],
  );

  return (
    <Section title='Данные парковочного места' testId='parkingDataSection'>
      <Typography variant='body3' data-testid='parkingOffice'>
        {bookingData}
      </Typography>

      {guest && (
        <BookingObjectAttribute testId='guestParking'>
          Гостевое место
        </BookingObjectAttribute>
      )}
    </Section>
  );
};
